<template>
    <div class="middle">
        <div>
            <h1 style="font-family: Code; margin: 0 auto"><b>Randy Mbiya</b></h1>
            <p style="margin: 25px;">Portfolio en maintenance <br> Je vous remercie pour votre patience !</p>
        </div>
    </div>
</template>
  
  <script>
  export default {
    name: 'MaintenancePage'
  };
  </script>
  
  <style scoped>
    .middle {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      height: 100vh;
    }
  </style>